import { settingsAtom } from "core/shared";
import { Instagram } from "~/design-system/components";
import { URLS } from "~/shared/urls";

export const footerLinks = {
  pages: [
    {
      label: "home",
      value: URLS.home,
    },
    {
      label: "aboutUs",
      value: URLS.infoPages.aboutUs,
    },
    {
      label: "contactUs",
      value: URLS.contactUs,
    },
    {
      label: "ourCakes",
      value: URLS.ourCakes.list,
    },
    {
      label: "flavorList",
      value: URLS.flavorList.list,
    },
    {
      label: "termsAndConditions",
      value: URLS.infoPages.termsConditions,
    },
    {
      label: "privacyPolicy",
      value: URLS.infoPages.privacyPolicy,
    },
    // {
    //   label: "exchangeAndReturnPolicy",
    //   value: URLS.infoPages.exchangeAndReturnPolicy,
    // },
  ],
  contact: [
    {
      label: settingsAtom?.value?.contact?.email,
      value: "503 FM359, #180, Richmond,TX  77406",
    },
    {
      label: settingsAtom?.value?.contact?.phone,
      value: settingsAtom?.value?.contact?.phone,
    },
    {
      label: settingsAtom?.value?.contact?.email,
      value: settingsAtom?.value?.contact?.email,
    },
  ],
  openingHours: [
    {
      label: "Mon - Fri",
      value: "9:00 am - 6:00 pm",
    },
    {
      label: "Sat",
      value: "10:00 am - 6:00 pm",
    },
    {
      label: "Sun",
      value: "Closed",
    },
  ],
  socialMedia: [
    {
      label: (
        <Instagram className="hover:text-primary-default size-8 transition-colors duration-300" />
      ),
      value: "https://www.instagram.com/nannis_cakes",
    },
  ],
};
